// StarIcon.jsx
import React from "react";

const StarIcon = ({
  color = "#facc15", // yellow-400
  size = "18",
  className = "",
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    className={`inline-block align-middle ${className}`}
  >
    <path d="m11.99 3.01.03.02 2.81 6.03 1.1.13 5.49.67.01.05-4.05 3.77-.81.76.21 1.09 1.06 5.43-.04.03-5.81-3.23-5.81 3.23-.04-.03 1.06-5.43.21-1.09-.81-.76-4.05-3.77.02-.05 5.49-.67 1.1-.13 2.81-6.03s.02-.02.03-.02m-.01-2c-.79 0-1.51.46-1.84 1.17L7.81 7.2l-5.49.67c-.78.1-1.44.64-1.68 1.39-.24.75-.03 1.58.55 2.11l4.05 3.77-1.06 5.43c-.15.77.16 1.57.8 2.03.35.26.77.39 1.19.39.34 0 .68-.08.99-.26L12 20.04l4.84 2.69c.31.17.65.26.99.26.42 0 .84-.13 1.19-.39.64-.46.95-1.26.8-2.03l-1.06-5.43 4.05-3.77c.58-.54.79-1.36.55-2.11-.24-.75-.9-1.29-1.68-1.39l-5.49-.67-2.34-5.02a2.015 2.015 0 0 0-1.84-1.17h-.02Z" />
  </svg>
);

export default StarIcon;